import React, { Component } from "react";
import { connect } from "react-redux";
import { updateRopeEndControl } from "../actions/";

class RopeEndControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ropeEndControl: []
    };
    this.handleOnchange = this.handleOnchange.bind(this);
  }

  handleOnchange = selected => {
    this.props.onRopeEndControlSelect(JSON.parse(selected.target.value));
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.pressureRoller !== prevProps.pressureRoller ||
      this.props.previewStatus !== prevProps.previewStatus
    ) {
      if (this.props.previewStatus !== null) {
        this.props.onRopeEndControlSelect({
          value: "without rope end control",
          orderCode: "00",
          weight: 0
        });
      }

      if (this.props.pressureRoller.orderCode === "00") {
        this.setState(
          {
            ropeEndControl: [
              {
                value: "without rope end control",
                orderCode: "00",
                weight: 0
              }
            ]
          },
          () => {
            this.props.onRopeEndControlSelect({
              value: "without rope end control",
              orderCode: "00",
              weight: 0
            });
          }
        );
      } else {
        if (
          this.props.mType === "metric" &&
          this.props.winchType.orderCode === "05"
        ) {
          this.setState({
            ropeEndControl: [
              {
                value: "without rope end control",
                orderCode: "00",
                weight: 0
              },
              {
                value: "with rope end control 3 safety windings",
                orderCode: "13",
                weight: 1.5
              },
              {
                value: "with rope end control 5 safety windings",
                orderCode: "15",
                weight: 1.5
              }
            ]
          });
        } else if (
          this.props.mType === "imperial" &&
          this.props.winchType.orderCode === "05"
        ) {
          this.setState({
            ropeEndControl: [
              {
                value: "without rope end control",
                orderCode: "00",
                weight: 0
              },
              {
                value: "with rope end control 3 safety windings",
                orderCode: "13",
                weight: 3.3
              },
              {
                value: "with rope end control 5 safety windings",
                orderCode: "15",
                weight: 3.3
              }
            ]
          });
        } else if (this.props.mType === "imperial") {
          this.setState({
            ropeEndControl: [
              {
                value: "without rope end control",
                orderCode: "00",
                weight: 0
              },
              {
                value: "with rope end control 3 safety windings",
                orderCode: "13",
                weight: 1.1
              },
              {
                value: "with rope end control 5 safety windings",
                orderCode: "15",
                weight: 1.1
              }
            ]
          });
        } else {
          this.setState({
            ropeEndControl: [
              {
                value: "without rope end control",
                orderCode: "00",
                weight: 0
              },
              {
                value: "with rope end control 3 safety windings",
                orderCode: "13",
                weight: 0.5
              },
              {
                value: "with rope end control 5 safety windings",
                orderCode: "15",
                weight: 0.5
              }
            ]
          });
        }
      }
    }
  }

  render() {
    var ropeEndControl =
      this.props.pressureRoller.orderCode !== "00" ? (
        this.state.ropeEndControl.map((red, index) => {
          return (
            <div className="col-md-6" key={index}>
              <label>
                <input
                  type="radio"
                  value={JSON.stringify(red)}
                  name="rope_end_control"
                  defaultChecked={
                    this.props.ropeEndControl.orderCode
                      ? this.props.ropeEndControl.orderCode === red.orderCode
                      : index === 0
                  }
                />{" "}
                {red.value}
              </label>
            </div>
          );
        })
      ) : (
        <div className="col-md-6">
          <label>
            <input
              type="radio"
              value={JSON.stringify({
                value: "Without rope end control",
                orderCode: "00",
                weight: 0
              })}
              name="rope_end_control"
              defaultChecked={true}
            />{" "}
            Without rope end control
          </label>
        </div>
      );
    return (
      <div>
        <div className="field-top">Rope end control</div>
        <div className="selection-body">
          <p>
            For safety reasons the rope end control is recommended. It makes
            sure that the rope is not completely pulled off the winch, thus
            supporting the operator and reduces the risk of operator errors.
            Only available in combination with option pressure roller.
          </p>
          <div className="row" onChange={this.handleOnchange}>
            {ropeEndControl}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    pressureRoller: state.pressureRoller,
    ropeEndControl: state.ropeEndControl,
    previewStatus: state.previewStatus
  };
};

const mapActionsToProps = {
  onRopeEndControlSelect: updateRopeEndControl
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(RopeEndControl);



// WEBPACK FOOTER //
// ./src/components/ropeEndControl.js